










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class KnowMoreBtn extends Vue {
  /**
   * 是否使用白色样式
   */
  @Prop({ default: false })
  private iswhitestyle!: boolean;
  /**
   * 按钮内部的文字
   */
  @Prop()
  private text!: string;

  private btnClick() {
    // window.console.log('btnClick');
    this.$emit('btn-click');
  }
}
